export const EFL_CHAMPIONSHIP = 'EFL Champ';
export const EFL_LEAGUE_ONE = 'EFL L1';
export const EFL_LEAGUE_TWO = 'EFL L2';
export const EPL = 'EPL';
export const US_MLS = 'US MLS';
export const UCL = 'UCL';
export const UEL = 'UEL';
export const SPFL = 'Scottish Premiership';
export const SERIE_A = 'Serie A';
export const WORLD_CUP_26 = 'World Cup 2026';
